<template>
  <div>
    <a-card>
      <a-tabs v-model="sysTabs"
              size="small"
              @change="queryListhy">
        <a-tab-pane key="1"
                    tab="管网运营报警"
                    force-render> </a-tab-pane>
        <a-tab-pane key="5"
                    tab="二次供水报警"
                    force-render> </a-tab-pane>
      </a-tabs>
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备编码">
                <a-input v-model="query.flowMeterNo"
                         placeholder="请输入设备编码"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12"
                   v-if="this.pumpNames">
              <a-form-item label="泵房名称">
                <a-input v-model="query.pumpName"
                         placeholder="请输入泵房名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="报警级别">
                <a-select placeholder="请选择报警级别"
                          v-model="query.alarmLevel"
                          allow-clear>
                  <a-select-option value="报警"> 报警 </a-select-option>
                  <a-select-option value="预警"> 预警 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态"
                          v-model="query.isDispose"
                          allow-clear>
                  <a-select-option :value="0"> 未处理 </a-select-option>
                  <a-select-option :value="1"> 已处理 </a-select-option>
                  <a-select-option :value="2"> 已忽略 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id"
               :scroll="{ x: 2800 }"
               :columns="columns"
               :data-source="list"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :pagination="pagination"
               @change="pageChange"
               bordered>
        <span slot="type"
              slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="isDispose"
              slot-scope="text">
          <a-tag color="rgb(255, 99, 71)"
                 v-if="text == 0"> 未处理 </a-tag>
          <a-tag color="rgb(50, 205, 50)"
                 v-else-if="text == 1"> 已处理 </a-tag>
          <a-tag color="#1890ff"
                 v-else> 已忽略 </a-tag>
        </span>
        <span slot="actiontype"
              slot-scope="text">
          <span v-if="text == 0"><a-tag color="red">待处理</a-tag></span>
          <span v-else><a-tag color="green">已处理</a-tag></span>
        </span>
        <span slot="malfunctionLevel"
              slot-scope="text">
          <a-tag color="rgb(255, 0, 0)"
                 v-if="text == '报警'"> 报警 </a-tag>
          <a-tag color="rgb(255, 165, 0)"
                 v-else-if="text == '预警'"> 预警 </a-tag>
        </span>
        <span slot="action"
              slot-scope="text, record">
          <a @click="Deal(record.id)"
             style="margin-right: 10px">处理</a>
        </span>
      </a-table>

      <a-modal title="标记报警级别"
               okText="标记"
               width="50%"
               :visible="visible"
               :confirm-loading="confirmLoading"
               @ok="handleOk"
               @cancel="handleCancel">
        <a-form :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-select v-model="level"
                    @change="handleChange">
            <a-select-option v-for="(item, index) in typelist"
                             :key="index"
                             :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form>
      </a-modal>
      <a-modal title="处理报警"
               okText="处理"
               width="50%"
               :visible="showdeal"
               @ok="handleDealOk"
               @cancel="handleDealCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['processor', { rules: [{ required: true, message: '请输入处理人!' }] }]" />
          </a-form-item>
          <a-form-item label="报警描述">
            <a-input v-decorator="['malfunctionDescribe', { rules: [{ required: true, message: '请输入报警描述!' }] }]" />
          </a-form-item>
          <a-form-item label="处理结果">
            <a-select v-decorator="['disposeResult', { rules: [{ required: true, message: '请选择处理结果!' }] }]"
                      placeholder="选择处理结果"
                      @change="handleSelectChange">
              <a-select-option :value="0"> 待处理 </a-select-option>
              <a-select-option :value="1"> 已处理 </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="处理方式">
            <a-input v-decorator="['processMode', { rules: [{ required: true, message: '请输入处理方式!' }] }]" />
            <a-select v-decorator="['processMode', { rules: [{ required: true, message: '请选择处理方式!' }] }]"
                      placeholder="选择处理方式"
                      @change="handleDealSelectChange">
              <a-select-option value="自行处理"> 自行处理 </a-select-option>
              <a-select-option value="他人处理"> 他人处理 </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      id: '',
      level: '选择报警级别',
      showdeal: false,
      queryUrl: '/pipe-network/remote_water_meter_alarm_messages/page',
      deleteUrl: '/pipe-network/remote_water_meter_alarm_messages/',
      modifyUrl: '/pipe-network/water_works_malfunctions',
      visible: false,
      confirmLoading: false,
      pumpNames: false,
      list: [],
      sysTabs: '1',
      query: {
        pumpName: '',
        flowMeterNo: '',
        processor: '',
        alarmLevel: '',
        isDispose: 0,
        sysTabs: '0,1,2',
        sysTab: '0',
        tenantId: this.$store.state.user.info.tenantId,
      },
      resultType: [0, 1],
      typelist: ['重要', '中等', '一般'],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '设备编号',
          width: 200,
          align: 'center',
          ellipsis: true,
          dataIndex: 'flowMeterNo',
        },
        {
          title: '报警位置',
          dataIndex: 'msgAddress',
          width: 200,
          align: 'center',
          ellipsis: true,
        },

        {
          title: '报警级别',
          dataIndex: 'alarmLevel',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'malfunctionLevel' },
        },
        {
          title: '处理状态',
          width: 150,
          align: 'center',
          ellipsis: true,
          dataIndex: 'isDispose',
          scopedSlots: { customRender: 'isDispose' },
        },
        {
          title: '开始报警时间',
          dataIndex: 'createTime',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '最近一次报警时间',
          dataIndex: 'updateTime',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '报警指标',
          dataIndex: 'alarmIndex',
          width: 100,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '报警类型',
          dataIndex: 'alarmType',
          width: 150,
          align: 'center',
          ellipsis: true,
          // scopedSlots: { customRender: 'type'},
        },

        {
          title: '指标当前报警值',
          width: 200,
          align: 'center',
          ellipsis: true,
          dataIndex: 'prewarningValue',
        },
        {
          title: '报警次数',
          width: 100,
          align: 'center',
          ellipsis: true,
          dataIndex: 'num',
        },
        {
          title: 'X坐标',
          dataIndex: 'longitude',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
        {
          title: 'Y坐标',
          dataIndex: 'latitude',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '处理人',
          dataIndex: 'disposeName',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '处理时间',
          dataIndex: 'disposeTime',
          width: 200,
          align: 'center',
          ellipsis: true,
        },
      ],
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    },
  },
  created () {
    this.setSystemName()
  },
  methods: {
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}预警报警系统`)
    },
    queryListhy (value) {
      if (value == 1) {
        this.query.sysTabs = '0,1,2'
        this.query.sysTab = '0'
        this.columns.splice(2, 1)
        this.pumpNames = false
        this.queryList()
      } else {
        this.query.sysTabs = ''
        this.query.sysTab = '5'
        this.columns.splice(2, 0, {
          title: '泵房名称',
          width: 200,
          align: 'center',
          ellipsis: true,
          dataIndex: 'pumpName',
        })
        this.pumpNames = true
        this.queryList()
      }
    },
    resetList () {
      console.log('reset')
      this.query = {
        pumpName: '',
        flowMeterNo: '',
        processor: '',
        alarmLevel: '',
        isDispose: 0,
        sysTabs: this.query.sysTabs,
        sysTab: this.query.sysTab,
        tenantId: this.$store.state.user.info.tenantId,
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
      // this.loadData()
    },
    handleChange (e) {
      let params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token,
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put',
      }).then((data) => {

        this.queryList()
        this.visible = false
        this.level = '选择报警级别'
        this.$message.success('标记成功')
      })
    },
    handleSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({ isDispose: value })
    },
    handleDealSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({
        disposeResult: value,
      })
      // this.addOrUpdateForm.setFieldsValue(value)
    },
    // handleDealSelectChange(value) {
    //   console.log(value)
    //   this.form.setFieldsValue({
    //     processMode: value,
    //   })
    // },
    Deal (id) {
      this.id = id
      // this.addOrUpdateHandle(id);
      this.showdeal = true
    },
    addOrUpdateHandle (id) {
      this.id = id
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleDealOk () {
      console.log(this.id)
      this.form.validateFields((err, values) => {
        if (!err) {
          let year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          let now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          let params = {
            id: this.id,
            deviceName: values.disposeName,
            malfunctionDescribe: values.alarmContent,
            disposeResult: 1,
            // processMode: values.processMode,
            // disposeResult:values.disposeResult,
            // disposeResult: 1,
            processorTime: now,
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token,
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put',
          }).then((data) => {

            this.queryList()
            this.showdeal = false
            this.form.resetFields()
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel () {
      this.showdeal = false
    },
    handleOk () {
      this.visible = false
    },
    handleCancel (e) {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>